"use strict"

/*
 * Routing
 */

/**
 * Redirects browser to specified URL
 * @param {string} url - URL to go to
 * @param {boolean} relative - URL is within the site or not
 * @returns {boolean} - Always false
 */
function go(url, relative) {
	var base = ''

	if (typeof relative === 'undefined' || relative === true) {
		base = base_url
	}

	document.location.href = base + url

	return false
}

/**
 * Jumps back a page in browsing histroy
 * @returns {boolean} - Always false
 */
function go_back() {
	window.history.back()

	return false
}

/**
 * Opens a new window with given URL
 * @param {string} url - URL to open in the new window
 * @param {string} target - Name of the window
 * @returns {boolean} - Always false
 */
function new_window(url, target) {
	if (typeof target === 'undefined') {
		target = '_blank'
	}

	window.open(url, target)

	return false
}

/**
 * Reloads the current page
 * @param {boolean} hard - JS reload (false) or set URL (true)
 * @returns {boolean} - Always false
 */
function reload(hard) {
	if (typeof hard === 'undefined') {
		hard = false
	}

	if (hard) {
		location.reload()
	}
	else {
		var url = document.location.href

		document.location.href = url
	}

	return false
}

/**
 * Set elements to toggle target checkboxes
 * @param {string} class_name - CSS selector select elements
 * @returns {boolean} - Always false
 */
function set_yesno_checkers(class_name) {
	// Remove old bindings
	$('.' + class_name).unbind('click')

	// Add new binding
	$('.' + class_name).on('click', function() {
		var target_id = $(this).attr('data-target')
		var checked = $('#' + target_id).prop('checked')

		$('#' + target_id).prop('checked', !checked)
		$('#' + target_id).trigger('change')
	})

	return false
}
